import { nameIsBlank } from "../dataUtilities";
import { unknownName } from "../../constants/data";

const hasValue = (field) =>
  typeof field?.value === "string" ? field.value.trim() !== "" : !!field?.value; //blank/whitespace strings and falsy values count as empty

export const fieldsToStrings = (theFields) => {
    for (let fieldName in theFields) {
      const theField = theFields[fieldName];
      if (typeof theField.value === "string") {
        if (theField.value?.trim() === "") {
          theFields[fieldName] = null;
        } else {
          theFields[fieldName] = theField.value.trim();
        }
      } else {
        theFields[fieldName] = theField.value;
      }
    }
    return theFields;
  }; //helper for submit form, turns field objects into plain values and trims
  
  export const mapPersonArray = (personArray) => {
    return [...personArray]
    .filter((person) => !nameIsBlank(person))
    .map(person => fieldsToStrings({...person}));
  };//helper to convert a person array to strings
  
  export const mapPassengerArray = (personArray) => {
    return [...personArray]
    .filter((person) => {
      const { isInjured, ...otherFields } = person;
      return hasValue(isInjured) || Object.values(otherFields).some(hasValue);
    })
    .map((person) => nameIsBlank(person) ? {...person, lastName: {...person.lastName, value: unknownName} } : person)
    .map(person => fieldsToStrings({...person}));
  };//keeps a passenger if injured, or if any field is filled in; defaults a blank name to "(unknown)"